import * as firebase from 'firebase/app';
require('firebase/firestore');
import Notification from '../models/Notification.js';
import axios from "axios";

const state = {
  allNotifications: [],
  notificationToEdit: {}
};

const getters = {
  getNotifications: state => state.allNotifications,
  getNotificationToEdit: state => state.notificationToEdit
};

const actions = {
  getAllNotifications({
    commit
  }) {
    firebase.firestore().collection("notifications").onSnapshot(
      snapshot => {
        commit("setLoading", true);

        let notifications = [];
        snapshot.forEach(doc => {
          let n = new Notification(doc.id, doc.data().title, doc.data().message, doc.data().created);
          notifications.push(n);
        });
        commit("setNotifications", notifications);
        commit("setLoading", false);
      }, error => {
        commit("setLoading", false);
        console.error(error);
      }
    );
  },
  createNotification({
    commit
  }, notification) {
    firebase.firestore().collection("notifications").add({
        title: notification.title,
        message: notification.message,
        created: notification.created
      }).then(docRef => {
        console.log("Notification written with ID: ", docRef.id);
        sendNotification(notification.title, notification.message, docRef.id);
      })
      .catch(error => {
        console.error("Error adding notification: ", error);
      });
  },
  editNotification({
    commit
  }, notification) {
    firebase.firestore().collection("notifications").doc(notification.id).update({
      title: notification.title,
      message: notification.message
    }).then(docRef => {
      console.log("Notification " + notification.id + " has been updated.");
    }).catch(error => {
      console.error(error);
    });
  },
  deleteNotification({
    commit
  }, notification) {
    firebase.firestore().collection("notifications").doc(notification.id).delete()
      .then(result => {
        console.log("Deleted notification");
      }).catch(error => {
        console.error(error);
      });
  }
};

function sendNotification(title, body, dbID) {
  firebase.firestore().collection('keys').doc('messagingKey').get().then(doc => {
    let key = doc.data().key;

    axios({
      method: "post",
      url: "https://fcm.googleapis.com/fcm/send",
      headers: {
        "Content-Type": "application/json",
        Authorization: 'key=' + key
      },
      data: {
        notification: {
          title: title,
          body: body,
          click_action: "FLUTTER_NOTIFICATION_CLICK"
        },
        data: {
          dbID: dbID
        },
        to: "/topics/notifications",
        priority: "high",
      }
    });
  });
}

const mutations = {
  setNotifications(state, notifications) {
    state.allNotifications = notifications;
  },
  setNotificationToEdit(state, notification) {
    state.notificationToEdit = notification;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};